import {Fragment} from 'react'

import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

import Email from './Email'
import Input from './Input'

import {formatDate, formatCamelCase} from '../../lib/data'

const DATE_FIELDS = ['createdAt', 'sentAt', 'acceptedAt', 'updatedAt', 'lastLoginAt']

const FieldInput = ({label, errors}) => {
  switch(label) {
    case 'email':
      return <Email className='input' error={!!errors.email} helperText={errors.email?.message} dense={false} fullWidth />
    case 'status':
      return null
    default:
      return (
        <Input
          fullWidth
          className='input'
          error={!!errors[label]}
          label={formatCamelCase(label)}
          name={label}
          options={{required: `${formatCamelCase(label)} is required`}}
          helperText={errors[label]?.message}
        />
      )
  }
}

const Field = ({errors, ...props}) => {
  if (props.edit && (DATE_FIELDS.includes(props.label) || props.label === 'status')) {
    return null
  } else {
    return (
      <Fragment>
        <Paper className='container' elevation={0} component='div' sx={{bgcolor: 'Background'}}>
          {
            props.edit ?
              <FieldInput errors={errors} label={props.label} value={props.value} /> : (
              <Fragment>
                <Typography className='label' variant='body1'>{formatCamelCase(props.label)}</Typography>
                <Typography variant='body2'>
                  {
                    DATE_FIELDS.includes(props.label) ?
                      formatDate(props.value) :
                      props.value
                    }
                </Typography>
              </Fragment>
            )
          }  
        </Paper>
      </Fragment>
    )
  }
}

export default Field
